import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from '../Typography/Typography';
export const ErrorMessage = ({ error, errorMessage, id }) => {
    return error && errorMessage ? (_jsx("div", { role: "alert", children: _jsx(Typography, { className: "text-content-critical dark:text-content-critical-dark", weight: "medium", component: "p", variant: "footnote", mx: 16, my: 8, id: id, children: errorMessage }) })) : null;
};
